import { Component, OnInit } from '@angular/core';
import { NgbModule, NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { CustomerInputService } from '../Services/customer-input.service';
import { PostingService } from '../Services/posting.service';

@Component({
  selector: 'app-posting',
  templateUrl: './posting.component.html',
  styleUrls: ['./posting.component.css']
})
export class PostingComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  users: any;
  indata: any;
  posting_targets = [];
  posting: any = {
    posting_code: '',
    posting_date: '',
    area: '',
    posting_type: '1',
    cost: ''
  };
  error_msg: string = '';
  info_msg: string = '';

  modalReference: NgbModalRef;
  error_mdl: string = '';

  /** */
  displayMonths: number;
  navigation: string = 'select';
  outsideDays: string = 'visible';
  showWeekNumbers: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public auth: AuthService,
    public customerInputService: CustomerInputService,
    private modalService: NgbModal,
    private postingService: PostingService
  ) { }

  ngOnInit() {
    var posting_code = +this.route.snapshot.paramMap.get('id');
    this.getUserList();
    if (posting_code) {
      this.getPosting(posting_code);
    }
  }

  getUserList() {
    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      //this.divisions = list['division'];
      this.users = list['user'];
    });
  }

  getPosting(posting_code) {
    this.postingService.getPosting(posting_code).subscribe((res) => {
      this.posting = res['posting'];
      this.posting_targets = res['targets'];
    });
  }
  //追加モーダル
  dialogOpenAdd(type) {
    this.error_mdl = '';
    this.indata = {
      index: '',
      target_date: '',
      content_type: '1',
      attract_targets: 0,
      user_code: 0,
    }
    this.modalReference = this.modalService.open(type);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  addTarget() {
    this.posting_targets.push(Object.assign({}, this.indata));
  }
  //更新モーダル
  dialogOpenUpd(type, idx) {
    this.error_mdl = '';
    let data = this.posting_targets[idx];
    this.indata = {
      index: idx,
      target_date: data.target_date,
      content_type: data.content_type,
      attract_targets: data.attract_targets,
      user_code: data.user_code,
    }
    this.modalReference = this.modalService.open(type);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  updTarget() {
    this.posting_targets[this.indata.index] = Object.assign({}, this.indata);
  }
  //削除モーダル
  dialogOpenDel(type, idx) {
    this.error_mdl = '';
    let data = this.posting_targets[idx];
    this.indata = {
      index: idx,
      target_date: data.target_date,
      content_type: data.content_type,
      attract_targets: data.attract_targets,
      user_code: data.user_code,
      del_chk: ''
    }
    this.modalReference = this.modalService.open(type);
    this.modalReference.result.then((result) => { }, (reason) => { });
  }
  delTarget() {
    this.posting_targets.splice(this.indata.index, 1);
  }
  // 保存
  save() {
    this.info_msg = '';
    this.error_msg = '';
    if (this.posting['posting_code']) {
      this.postingService.updPosting(this.posting, this.posting_targets).subscribe((res) => {
        if (res['error'] && res['error'] == 1) {
          this.error_msg = '登録に失敗しました';
        } else {
          this.info_msg = '登録しました';
          this.createPosting(res['posting']);
          this.createPostingTarget(res['targets']);
        }
      });
    } else {
      this.postingService.addPosting(this.posting, this.posting_targets).subscribe((res) => {
        if (res['error'] && res['error'] == 1) {
          this.error_msg = '登録に失敗しました';
        } else {
          this.info_msg = '登録しました';
          //console.log('addPosting', res);
          this.createPosting(res['posting']);
          this.createPostingTarget(res['targets']);
        }
      });
    }
  }
  delete() {
    this.info_msg = '';
    this.error_msg = '';
    if (this.posting['posting_code']) {
      this.postingService.delPosting(this.posting['posting_code']).subscribe((res) => {
        if (res['error'] && res['error'] == 1) {
          this.error_msg = '登録に失敗しました';
        } else {
          this.info_msg = '削除しました';
          this.posting = {};
          this.posting_targets = [];
        }
      });
    } else {
      this.info_msg = '削除しました';
      this.posting = {};
      this.posting_targets = [];
    }
  }
  createPosting(postingDate) {
    this.posting = {
      posting_code: postingDate.posting_code,
      posting_date: this.dateString2Obj(postingDate.posting_date),
      area: postingDate.area,
      posting_type: '' + postingDate.posting_type,
      cost: postingDate.cost
    }
  }
  createPostingTarget(targetData) {
    var list = []
    targetData.forEach((target) => {
      let newdata = Object.assign({}, target);
      newdata.target_date = this.dateString2Obj(newdata.target_date);
      newdata.content_type = '' + newdata.content_type;
      list.push(newdata);
    });
    this.posting_targets = list;
  }
  cal2Date(indata) {
    if (indata.year && indata.month && indata.day) {
      return new Date(indata.year, indata.month - 1, indata.day);
    }
    return indata;
  }
  dateString2Obj(str) {
    if (str) {
      let ary = str.split(/[- :\/]/);
      if (ary.length > 2) {
        return { year: parseInt(ary[0], 10), month: parseInt(ary[1], 10), day: parseInt(ary[2], 10) };
      }
    }
    return str;
  }
}
